import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import InviteEmailDesignTemplatePreview from 'features/InviteEmailDesign/InviteEmailDesignTemplatePreview'
import { Link } from 'react-router-dom'

import styles from './InviteEmailDesign.module.scss'

const InviteEmailDesignTemplatePreviewModal = ({ template, onClose }) => {
  if (!template) {
    return null
  }

  return (
    <ConfirmationDialog
      title={template.name || 'Email template preview'}
      negativeMessage="Close"
      confirmLink={`/marketing-assets/email-templates/${template.id}`}
      positiveMessage="Edit template"
      onClose={onClose}
      maxWidth={620}
      contentPadding="0 18px 18px"
      allowOverflow
    >
      <p className={styles.previewModalHint}>
        Template look only — campaign message text is edited per invite campaign.
      </p>
      <InviteEmailDesignTemplatePreview
        templateId={template.id}
        variant="modal"
        enabled
      />
      <Link
        className={styles.previewModalEditLink}
        to={`/marketing-assets/email-templates/${template.id}`}
      >
        Open full editor
      </Link>
    </ConfirmationDialog>
  )
}

export default InviteEmailDesignTemplatePreviewModal
